import styled from "styled-components";
import PropTypes from "prop-types";
import { desktopMarginsCutoff } from "../../styleConstants";

const PrimaryContact = styled.div`
  color: rgba(0, 0, 0, 0.95);
  font-size: 16px;
  font-weight: 500;
`;

const AltContacts = styled.div`
  color: rgba(0, 0, 0, 0.55);
  font-size: 16px;
`;

const AltContact = styled.div`
  margin-top: 4px;
`;

const ContactNote = styled.div`
  margin-top: 12px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    font-size: 14px;
  }
`;

const ContactsSection = ({ primaryContact, altContacts }) => {
  const hasSingleContact = altContacts.length === 0;
  const contactsMessage = hasSingleContact
    ? "Need to add a contact to your account? Reach out to us by phone or email."
    : "Need to add or remove a contact? Reach out to us.";

  return (
    <>
      <PrimaryContact>{primaryContact}</PrimaryContact>
      <AltContacts>
        {altContacts.map((contact, i) => (
          <AltContact key={i}>{contact}</AltContact>
        ))}
      </AltContacts>
      <ContactNote>{contactsMessage}</ContactNote>
    </>
  );
};

ContactsSection.propTypes = {
  primaryContact: PropTypes.string,
  altContacts: PropTypes.arrayOf(PropTypes.string),
};

export default ContactsSection;
